import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-28 px-6 md:px-12 relative overflow-hidden" style={{
    backgroundColor: '#F4F6ED'
  }} data-id="element-16">
      {/* Decorative elements */}
      <div className="absolute top-40 left-10 w-20 h-20 border border-dashed border-ink-300 rounded-full opacity-30" data-id="element-17"></div>
      <div className="absolute bottom-40 right-10 w-16 h-16 border border-dotted border-ink-300 rounded-full opacity-30" data-id="element-18"></div>
      <div className="absolute top-1/2 right-20 w-24 h-px bg-ink-300 opacity-30" data-id="element-19"></div>
      <div className="absolute top-1/2 left-20 w-24 h-px bg-ink-300 opacity-30" data-id="element-20"></div>
      <div className="container mx-auto max-w-6xl" data-id="element-21">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-23">
            <div className="w-12 h-1 bg-ink-900 mb-8" data-id="element-24"></div>
            <div className="relative inline-block mb-8" data-id="element-25">
              <h2 className="text-3xl md:text-4xl font-currency italic tracking-wide currency-ornament" data-id="element-26">
                About
              </h2>
            </div>
            <p className="text-ink-600 mb-6 font-serif" data-id="element-27">
              My journey began as a software engineer, writing code and building
              systems from the ground up. Over time, I discovered my passion for
              the intersection of technology, design, and business strategy.
            </p>
            <p className="text-ink-600 mb-6 font-serif" data-id="element-28">
              Today, I help product teams navigate complexity by focusing on
              three core principles: discovery, opportunity trees, and
              experiments. This approach allows teams to make informed decisions
              even in ambiguous environments.
            </p>
            <p className="text-ink-600 font-serif" data-id="element-29">
              With experience spanning B2B SaaS, eCommerce, and AI applications,
              I bring a unique perspective that bridges technical feasibility
              with business viability and user desirability.
            </p>
          </motion.div>
          <motion.div className="relative" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-30">
            {/* Replaced solid circles with line-based circles */}
            <div className="absolute -top-10 -right-10 w-24 h-24 rounded-full border border-ink-200" data-id="element-31"></div>
            <div className="absolute -bottom-8 -left-8 w-16 h-16 rounded-full border border-ink-200" data-id="element-32"></div>
            <div className="bg-white border border-ink-100 p-10 relative z-10" data-id="element-33">
              {/* Added decorative corner lines */}
              <div className="absolute top-0 left-0 w-5 h-5 border-t border-l border-ink-200" data-id="element-34"></div>
              <div className="absolute top-0 right-0 w-5 h-5 border-t border-r border-ink-200" data-id="element-35"></div>
              <div className="absolute bottom-0 left-0 w-5 h-5 border-b border-l border-ink-200" data-id="element-36"></div>
              <div className="absolute bottom-0 right-0 w-5 h-5 border-b border-r border-ink-200" data-id="element-37"></div>
              <div className="mb-10" data-id="element-38">
                <h3 className="text-xl font-currency tracking-wide mb-4" data-id="element-39">
                  Discovery
                </h3>
                <p className="text-ink-600 font-serif" data-id="element-40">
                  Uncovering user needs and business opportunities through
                  structured research and analysis.
                </p>
              </div>
              <div className="mb-10" data-id="element-41">
                <h3 className="text-xl font-currency tracking-wide mb-4" data-id="element-42">
                  Opportunity Trees
                </h3>
                <p className="text-ink-600 font-serif" data-id="element-43">
                  Mapping potential paths to create value, prioritizing based on
                  impact and feasibility.
                </p>
              </div>
              <div data-id="element-44">
                <h3 className="text-xl font-currency tracking-wide mb-4" data-id="element-45">
                  Experiments
                </h3>
                <p className="text-ink-600 font-serif" data-id="element-46">
                  Testing hypotheses with minimal investment to validate
                  assumptions before scaling.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto mt-32 px-6" data-id="element-47">
        <div className="h-px bg-ink-200 w-full" data-id="element-48"></div>
      </div>
    </section>;
}